import { Tool } from '@cyborg-monorepo/hunter/common'

import {
  supportedToolUrl,
  getSearchURLForContent,
} from '../../../../helpers/utils'

// This function generates a search URL for the provided tool and content.
export const getToolSearchUrl = (tool: Tool, content: string): string => {
  if (supportedToolUrl(tool.product))
    return getSearchURLForContent(tool, content)
  else return ''
}
